module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "link": "/services",
      "title": "Services"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.menuServices), function(service, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ({
          el: service.hash,
          offset: -100
        }),
        expression: "{el: service.hash, offset: -100}"
      }],
      staticClass: "nav-item",
      class: _vm.activeService == service ? 'active' : null,
      on: {
        "click": function($event) {
          return _vm.setActiveService(index)
        }
      }
    }, [_vm._v(_vm._s(service.title))])])
  }), 0)])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sub-sections"
    }
  }, [_c('div', {
    staticClass: "sub-section",
    attrs: {
      "id": "services"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.services), function(service, index) {
    return _c('service', {
      key: index,
      attrs: {
        "service": service,
        "active": _vm.activeService == service
      },
      on: {
        "activated": function($event) {
          return _vm.setActiveService(index)
        }
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    staticClass: "align-right",
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("We want to help you out, and we do a lot of things, so odds are that what you need done matches up with what we're able to do. Whether you need help fleshing out your idea and how to implement it, or you need help building out what you've already planned, or you just need some things fixed and maintained, we've got you covered.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43a59864","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/Services.vue
// module id = 913
// module chunks = 1